import $ from 'jquery';
import 'slick-carousel';
import bindEvent from '../../scripts/util/bindEvent';
import sampleTabs from '../sample-tabs/';
import isElement from '../../scripts/util/isElement';

const selectors = {
	el: '.js-example',
	slider: '.js-slider-example',
	toggle: '.js-example-toggle',
	bar: {
		inner: '.js-example-inner-bar',
		outer: '.js-example-outer-bar'
	}
};

const classes = {
	slider: {
		mobile: 'slider-example_type_mobile'
	},
	toggle: {
		active: 'example__toggle_state_active'
	},
	bar: {
		disable: 'slider-example__bar_state_disable'
	}
};

const slickSettings = {
	prevArrow: '<div class= "slider-example__arrow slider-example__arrow_type_left arrow arrow_type_left"></div>',
	nextArrow: '<div class= "slider-example__arrow slider-example__arrow_type_right arrow hidden-open-menu"></div>',
	infinite: true,
	dots: false,
	speed: 1000,
	fade: true,
	adaptiveHeight: false,
	waitForAnimate: false,
	responsive: [{
		breakpoint: 768,
		settings: {
			arrows: false,
			dots: true,
			fade: false,
			touchThreshold: 5,
			swipeToSlide: true,
			waitForAnimate: true,
			speed: 300
		}
	}]
};


// const guideSlickSettings = {
// 	prevArrow: '<div class= "slider-example__arrow slider-example__arrow_type_left arrow arrow_type_left"></div>',
// 	nextArrow: '<div class= "slider-example__arrow slider-example__arrow_type_right arrow hidden-open-menu"></div>',
// 	infinite: true,
// 	dots: false,
// 	speed: 1000,
// 	fade: true,
// 	adaptiveHeight: false,
// 	waitForAnimate: false,
// 	responsive: [{
// 		breakpoint: 1025,
// 		settings: {
// 			arrows: false,
// 			dots: true,
// 			fade: false,
// 			touchThreshold: 5,
// 			swipeToSlide: true,
// 			waitForAnimate: true,
// 			speed: 300
// 		}
// 	}]
// };


const slickCarousel = settings => {
	const slider = $(selectors.slider).filter(':visible');

	slider.each( function () {
		if ( !slider.hasClass('slick-initialized') ) {
			slider.on('init', function (/* event,  slick  , direction */) {
				slider
					.closest('.example__review')
					.removeClass('example__review_hidden')
					.prev('.example__info')
					.removeClass('example__info_hidden');
			});

			slider.slick(settings);
		} else {
			slider.slick('refresh');
		}
	});

};


const toggleView = e => {
	// console.log( 'toggle view' );
	const target = e.currentTarget;
	const type = target.getAttribute('data-type');
	const el = document.querySelector(selectors.el);
	const active = document.querySelector(`.${classes.toggle.active}`);


	if (type === 'desktop') {
		el.classList.remove(classes.slider.mobile);
	} else {
		el.classList.add(classes.slider.mobile);
	}

	active.classList.remove(classes.toggle.active);
	target.classList.add(classes.toggle.active);

};

const render = () => {

	if (isElement(selectors.el)) {
		slickCarousel(slickSettings);
		bindEvent(selectors.toggle, 'click', toggleView);

		sampleTabs();
	}

	$('.js-example-back-link').on('click', function () {
		history.go(-1);
	});

	// bindEvent('.js-accordeon', 'jsaccordeonclick', slickCarousel(slickSettings)); //not work for custom event?!
	$('.js-accordeon').on('jsaccordeonclick', function () {
		slickCarousel(slickSettings);
	});

};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/example/example.js